(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accordion"] && !Shopify.designMode) return;
  try {
    class PrefabAccordion extends HTMLElement {
    connectedCallback() {
      const singleOpen = this.dataset.singleOpen === 'true';
      const openFirst = this.dataset.openFirst === 'true';

      customElements.whenDefined('collapsible-content').then(() => {
        const collapsibleItems = this.querySelectorAll('collapsible-content');

        // Open first item if setting is enabled
        if (openFirst && collapsibleItems.length > 0) {
          collapsibleItems[0].openContent();
        }

        // Handle single open mode
        if (singleOpen) {
          collapsibleItems.forEach((item) => {
            item.toggleButton.addEventListener('click', function () {
              collapsibleItems.forEach((otherItem) => {
                if (otherItem !== item) {
                  otherItem.closeContent();
                }
              });
            });
          });
        }
      });
    }
  }

  customElements.define('prefab-accordion', PrefabAccordion);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["collapsible-accordion"] && !Shopify.designMode) return;
  try {
    class CollapsibleAccordion extends HTMLElement {
    connectedCallback() {
      this.toggleButton = this.querySelector(':scope > button');
      this.content = this.querySelector(`#${this.toggleButton.getAttribute('aria-controls')}`);

      this.toggleButton.addEventListener('click', () => {
        const isExpanded = this.toggleButton.getAttribute('aria-expanded') === 'true';

        if (isExpanded) {
          this.closeContent();
        } else {
          this.openContent();
        }
      });
    }

    openContent() {
      this.toggleButton.setAttribute('aria-expanded', 'true');
      this.content.setAttribute('aria-hidden', 'false');
    }

    closeContent() {
      this.toggleButton.setAttribute('aria-expanded', 'false');
      this.content.setAttribute('aria-hidden', 'true');
    }
  }

  customElements.define('collapsible-accordion', CollapsibleAccordion);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["image-carousel"] && !Shopify.designMode) return;
  try {
    class ImageCarousel extends HTMLElement {
    connectedCallback() {
      const swiperEl = this.querySelector('.swiper');
      if (!swiperEl) return;

      new Swiper(swiperEl, {
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        centeredSlides: true,
        loop: swiperEl.dataset.swiperLoop,
        enabled: swiperEl.dataset.swiperEnabled,
        autoHeight: swiperEl.dataset.swiperAutoHeight,
        pagination: {
          el: swiperEl.querySelector('.swiper-pagination'),
          clickable: true,
        },
        navigation: {
          nextEl: swiperEl.querySelector('.swiper-button-next'),
          prevEl: swiperEl.querySelector('.swiper-button-prev'),
          addIcons: false,
        },
      });
    }
  }

  customElements.define('image-carousel', ImageCarousel);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["team-members"] && !Shopify.designMode) return;
  try {
    class TeamMembers extends HTMLElement {
    connectedCallback() {
      const swiperEl = this.querySelector('.swiper');
      if (!swiperEl) return;

      new Swiper(swiperEl, {
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        centeredSlides: true,
        loop: true,
        enabled: true,
        autoHeight: true,
        pagination: {
          el: swiperEl.querySelector('.swiper-pagination'),
          clickable: true,
        },
        navigation: {
          nextEl: swiperEl.querySelector('.swiper-button-next'),
          prevEl: swiperEl.querySelector('.swiper-button-prev'),
          addIcons: false,
        },
      });
    }
  }

  customElements.define('team-members', TeamMembers);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["testimonials"] && !Shopify.designMode) return;
  try {
    class TestimonialsBlock extends HTMLElement {
    connectedCallback() {
      const swiperEl = this.querySelector('.swiper');
      if (!swiperEl) return;

      new Swiper(swiperEl, {
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        centeredSlides: true,
        loop: true,
        autoHeight: true,
        pagination: {
          el: swiperEl.querySelector('.swiper-pagination'),
          clickable: true,
        },
        navigation: {
          nextEl: swiperEl.querySelector('.swiper-button-next'),
          prevEl: swiperEl.querySelector('.swiper-button-prev'),
          addIcons: false,
        },
      });
    }
  }

  customElements.define('testimonials-block', TestimonialsBlock);
  } catch(e) { console.error(e); }
})();

})();
